import { useState } from 'react';

export default function AddProduct({closeModal}) {
  const [fileName, setFileName] = useState('');
  const [verified, setVerified] = useState('Verified');

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg w-[950px] p-6 relative">
        {/* Close Icon */}
        <button
          className="absolute top-3 right-3 text-black text-2xl font-bold"
          onClick={closeModal}  // <-- Close modal when clicked
        >
          &times;
        </button>

        {/* Title */}
        <h2 className="text-xl font-semibold text-black mb-1">Add Products</h2>
        <p className="text-gray-500 text-sm mb-4">add your product with required fields</p>

        {/* Form Grid */}
        <div className="grid grid-cols-2 gap-4 text-sm space-y-4">
          <div className="flex flex-col">
            
            <input className="border-b border-gray-300 focus:outline-none py-1" placeholder="Enter Product Name" />
          </div>

          <div className="flex flex-col">
            
            <input className="border-b border-gray-300 focus:outline-none py-1" placeholder="Seller Name"/>
          </div>

          <div className="flex flex-col">
           
            <div className="flex items-center gap-2">
              <input className="border-b border-gray-300 focus:outline-none py-1 w-full" placeholder="Product Price" />
              <select className="border-b border-gray-300 focus:outline-none">
                <option>USD</option>
                <option>INR</option>
              </select>
            </div>
          </div>

          <div className="flex flex-col">
          
            <input className="border-b border-gray-300 focus:outline-none py-1" placeholder="Enter Old Price it will show like : ₹3000" />
          </div>

          <div className="flex flex-col ">
            
            <input className="border-b border-gray-300 focus:outline-none py-1" placeholder="Enter Offer price it will show like : up to 30% off" />
          </div>

          <div className="flex flex-col">
           
            <input className="border-b border-gray-300 focus:outline-none py-1" placeholder="Enter  Country" />
          </div>

          <div className="flex items-center gap-9 col-span-2 mt-1 ">
            <label className="flex items-center gap-1">
              <input
                type="radio"
                name="verify"
                checked={verified === 'Verified'}
                onChange={() => setVerified('Verified')}
              />
              Verified
            </label>
            <label className="flex items-center g">
              <input
                type="radio"
                name="verify"
                checked={verified === 'Non Verified'}
                onChange={() => setVerified('Non Verified')}
              />
              Non Verified
            </label>
          

          <div className="col-span-2 ms-56">
            <label>Product Images<span className="text-red-500">*</span></label>
            <div className="flex items-center gap-2 mt-1 border-2 w-[450px]">
              <label className="border border-gray-400 px-2 py-1 cursor-pointer bg-gray-100">
                Choose File
                <input
                  type="file"
                  className="hidden"
                  onChange={(e) => setFileName(e.target.files[0]?.name || '')}
                />
              </label>
              {fileName && <span className="text-sm">{fileName}</span>}
            </div>
          </div>
          </div>

          <div className="col-span-2">
            <label>Write description about products <span className="text-red-500">*</span></label>
            <textarea
              className="w-full border border-gray-300 rounded-md mt-1 p-2 text-sm focus:outline-none"
              rows={4}
              placeholder="Write description..."
            />
          </div>
        </div>

        {/* Add Button */}
        <div className="flex justify-end mt-4">
          <button className="bg-sky-500 hover:bg-sky-600 text-white px-8 text-lg rounded">Add</button>
        </div>
      </div>
    </div>
  );
}
